import React from 'react';
import AddEditCouponForm from 'ui-component/coupons/AddEditCouponForm';


function EditCoupon() {
  return (
    <div>
      <AddEditCouponForm title="Edit Coupon" />
    </div>
  );
}

export default EditCoupon;
